export default __webpack_public_path__ + "static/media/webTech.fba67efa.svg";